import {
  PeriodEndReportFormValues,
  FullyValidatedPeriodEndReportFormValues,
} from './schema';
import { PeriodEndReport } from './types';

export const mapPeriodEndReportToFormValues = (
  periodEndReport?: PeriodEndReport,
): PeriodEndReportFormValues => ({
  useFullValidation: false,
  id: periodEndReport?.id ?? undefined,
  title: periodEndReport?.title ?? '',
  reportDate: periodEndReport?.reportDate ?? undefined,
  commentary: periodEndReport?.commentary ?? [],
  fundOverviewDatapoints: periodEndReport?.fundOverviewDatapoints ?? {
    general: {
      fundName: { included: false, value: '' },
      fundCurrency: { included: false, value: '' },
      vintageYear: { included: false, value: '' },
      displayCloseDate: { included: false, value: '' },
      totalCommitments: { included: false, value: '' },
      displayTotalCommitmentsPerClose: { included: false, value: '' },
      fundTerm: { included: false, value: '' },
      legalForm: { included: false, value: '' },
      formationJurisdiction: { included: false, value: '' },
      investmentAdviserManager: { included: false, value: '' },
      generalPartner: { included: false, value: '' },
      reinvestmentRecyclingPolicy: { included: false, value: '' },
    },
    investmentFocus: {
      stage: { included: false, value: '' },
      sector: { included: false, value: '' },
      geography: { included: false, value: '' },
    },
  },
  portfolioUpdateFile: periodEndReport?.portfolioUpdateFile
    ? {
        name: periodEndReport.portfolioUpdateFile.name,
        path: periodEndReport.portfolioUpdateFile.path,
        previewUrl: periodEndReport.portfolioUpdateFile.previewUrl,
      }
    : undefined,
  notificationPreferences: periodEndReport?.notificationPreferences ?? {
    notifyViaEmail: true,
    attachPdfUpdateToEmail: true,
  },
  recipients: periodEndReport?.recipients ?? [],
  resendPublishedUpdates: false,
});

export const mapFormValuesToSaveInput = (
  periodEndReport: PeriodEndReport,
  formData: PeriodEndReportFormValues,
) => ({
  id: formData.id ?? periodEndReport.id,
  vehicleId: periodEndReport.vehicleId,
  accountingPeriodId: periodEndReport.accountingPeriodId,
  status: periodEndReport.status,
  title: formData.title,
  reportDate: formData.reportDate,
  commentary: formData.commentary,
  fundOverviewDatapoints: formData.fundOverviewDatapoints,
  portfolioUpdateFile: formData.portfolioUpdateFile
    ? {
        name: formData.portfolioUpdateFile.name,
        path: formData.portfolioUpdateFile.path,
      }
    : undefined,
  notificationPreferences: formData.notificationPreferences,
  perInvestorNotificationSettings: formData.recipients.map((r) => ({
    investorId: r.investorId,
    notifyViaEmail: r.notifyViaEmail,
  })),
  resendPublishedUpdates: formData.resendPublishedUpdates,
});

export const mapFormValuesToPublishInput = (
  periodEndReport: PeriodEndReport & { id: string },
  formData: FullyValidatedPeriodEndReportFormValues,
) => ({
  ...mapFormValuesToSaveInput(periodEndReport, formData),
  id: periodEndReport.id,
  title: formData.title,
  reportDate: formData.reportDate,
  commentary: formData.commentary,
});
